export default function LocaleIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className="glo-nav-locale-icon">
            <path
                d="M21 12C21 16.9706 16.9706 21 12 21M21 12C21 7.02944 16.9706 3 12 3M21 12H15.6M12 21C7.02944 21 3 16.9706 3 12M12 21C13.9882 21 15.6 16.9706 15.6 12M12 21C10.0118 21 8.4 16.9706 8.4 12M3 12C3 7.02944 7.02944 3 12 3M3 12H8.4M12 3C10.0118 3 8.4 7.02944 8.4 12M12 3C13.9882 3 15.6 7.02944 15.6 12M15.6 12H8.4"
                stroke="currentColor"
                strokeWidth="1.5"
            />
        </svg>
    );
}

export const arrow = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.38489 12.7853L11.4497 7.95064L6.38489 3.11601" stroke="currentColor" strokeWidth="1.5" />
    </svg>
);
